module.exports = __webpack_public_path__ + "fonts/UniSansThin.02a0422b.woff2";